import { Component, Inject } from '@angular/core';
import { ModalService } from '../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { OperationDto } from '../../../api/dtos/OperationDto';
import { ApiClientAdminOperation } from '../../../api/endpoints/ApiClientAdminOperation';
import { OperationService } from './operation.service';
import { OperationStatus } from '../../../api/enums/OperationStatus';
import { NotificationService } from '../../../../../../libs/utils/ng-shared-components/src';
import { INotificationTrayService } from '../../../../../../libs/utils/ng-shared-components/src/lib/notification-tray/INotificationTray';

@Component({
  standalone: false,
  selector: 'mf-operation-edit',
  templateUrl: './operation-edit.component.html',
  styleUrls: ['./operation-edit.component.scss'],
})
export class OperationEditComponent {
  constructor(
    private _apiClientAdminOperation: ApiClientAdminOperation,
    private _modalService: ModalService,
    private _operationService: OperationService,
    private _notificationService: NotificationService,
    @Inject('INotificationTrayService') public notificationTrayService: INotificationTrayService
  ) {
    this.load();
  }

  isLoaded = false;

  async load() {
    this._operationService.operationDto = await this._apiClientAdminOperation.getById(this._modalService.openData.operationId);
    this.isLoaded = true;
  }

  async save(operationDto: OperationDto) {
    if (operationDto.status == OperationStatus.Draft) {
      await this.executeOperation(operationDto);
      this._modalService.closeAsSuccess();
    } else {
      await this.backToDraft(operationDto);
    }
  }

  async executeOperation(operationDto: OperationDto) {
    const operation = await this._apiClientAdminOperation.completeDraftAndStartCashing(operationDto.id);

    if (operation.status === OperationStatus.Cashing) {
      this._notificationService.showSuccess('Cambios confirmados con éxito.');
    }

    if (operation.status === OperationStatus.UnderReviewBeforeCashing) {
      this._notificationService.showWarning('La operación se encuentra en revisión, revise incidentes');
    }

    this.notificationTrayService.loadNotifications();
    this._operationService.reloadOperation(operationDto.id);
    this._modalService.closeAsSuccess();
  }

  async backToDraft(operationDto: OperationDto) {
    await this._apiClientAdminOperation.backToDraft(operationDto.id);
    this._operationService.reloadOperation(operationDto.id);
  }
}
